export enum EFont {
  AlergeyaSC = 'Alegreya SC',
  Alergeya = 'Alegreya'
}


